export enum GameState {
    Idle,
    Betting,
    GameStart,
    BaharWin = 0x7000,
    AndarWin
}